// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}


.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
    background-clip: padding-box;
    
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}

.active {
    background-color: teal !important;
    color: white;
}

.active td:nth-child(1) {
    color: white;
}

.child {
    background-color: white !important;
    border-left: 4px solid teal;
    border-right: 3px solid teal;
    border-bottom: 2px solid teal;
}

.input-control-manageFLeet:disabled, .input-control-manageFLeet[disabled] {
    border: 1px solid gray;
    box-shadow: none !important;
    background-color: #e2e2e2;
    transition: none;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/account-group-management/account-group-management.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;IACV,4BAA4B;;AAEhC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;AACpB;AACA,g/FAAg/F","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n    background-clip: padding-box;\r\n    \r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}\r\n\r\n.active {\r\n    background-color: teal !important;\r\n    color: white;\r\n}\r\n\r\n.active td:nth-child(1) {\r\n    color: white;\r\n}\r\n\r\n.child {\r\n    background-color: white !important;\r\n    border-left: 4px solid teal;\r\n    border-right: 3px solid teal;\r\n    border-bottom: 2px solid teal;\r\n}\r\n\r\n.input-control-manageFLeet:disabled, .input-control-manageFLeet[disabled] {\r\n    border: 1px solid gray;\r\n    box-shadow: none !important;\r\n    background-color: #e2e2e2;\r\n    transition: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
